/** Shared top loading bar controller — avoids circular imports with App/apiClient. */
export const loaderRef = {
  _instance: null,
  toggleLoader(loading) {
    loaderRef._instance?.toggleLoader(loading)
  }
}

export default loaderRef
